const ArticleShell = () => null

export default ArticleShell
